import axios from 'axios'
import { getRequestConfig } from 'src/queries/requestConfig'

interface G2ReviewTokenResponse {
  reviewEmbedUrl: string
}

export const fetchG2Token = async (): Promise<G2ReviewTokenResponse> => {
  const requestConfig = getRequestConfig()

  const response = await axios.post<G2ReviewTokenResponse>(
    '/g2-review-token',
    undefined,
    requestConfig,
  )
  return response.data
}
